export const StudentClassRequestedModelFields = [
  "id",
  "name",
  "description",
  "students_count",
  "color",
  "teachers_count",
  "owner",
];

export const ManagerClassRequestedModelFields = [
  "id",
  "name",
  "description",
  "students_count",
  "teachers_count",
];

export const GetStudentsInAssignmentAsManagerRequestedFields = [
  "id",
  "user_id",
  "points",
  "results",
  "scores",
  "attempts:id",
  "attempts:status",
  "attempts:state",
  "attempts:started_at",
  "attempts:finished_at",
  "attempts:created_at",
  "attempts:results",
  "attempts:variant",
  "attempts:points",
  "attempts:credibility",
  "attempts:credibility_verdict",
  "user:class_id",
  "user:id",
  "user:photo",
  "user:color",
  "user:firstname",
  "user:lastname",
  "user:patronymic",
  "user:email",
  "user:external_id",
  "user:is_online",
  "credibility",
  "student_certificate",
];

export const GetStudentsInAssignmentForProctoringFields = [
  "id",
  "user_id",
  "user:id",
  "user:photo",
  "user:color",
  "user:photo_thumb",
  "user:firstname",
  "user:lastname",
  "user:last_activity_date",
  "user:is_online",
];

export const GetStudentsAsManagerRequestedFields = [
  "id",
  "user_id",
  "user:id",
  "user:photo",
  "user:color",
  "user:photo_thumb",
  "user:firstname",
  "user:lastname",
  "user:last_activity_date",
  "user:is_online",
];


export const GetStudentsAsManagerFullInfoRequestedFields = [
  "id",
  "user_id",
  "user:id",
  "user:school_id",
  "user:external_id",
  "user:group",
  "user:firstname",
  "user:lastname",
  "user:patronymic",
  "user:username",
  "user:email",
  "user:phone",
  "user:photo",
  "user:photo_thumb",
  "user:color",
  "user:description",
  "user:is_need_complete_challenge",
  "user:is_online",
];
